import { ChangeEvent } from 'react'

import { DynamicInput, Form } from '@domain-group/suit-theme'

import usePortalDataInput from '../../hooks/usePortalDataInput'

const getCurrentValue = (inputType: string, value: string, defaultValue: string) => {
  if (inputType === 'bool'){
    return typeof value === 'undefined' || value === '' ? defaultValue : value
  }

  if (inputType === 'select'){
    return value || defaultValue
  }

  return value
}

const PortalDataInput = (props: {
  fieldKey: string,
  marginTop?: (string | number)[] | string,
  maxLength?: number,
  style?: object,
}) => {
  const {
    fieldKey, marginTop, maxLength, style,
  } = props

  const inputPayload = usePortalDataInput(fieldKey)
  const {
    conditionsValid,
    defaultValue,
    dataStoreItemFormPayload: {
      entityState: { value },
      handlers,
    },
    fieldSchema: {
      inputComponent, inputType, label, values, valueType,
    },
  } = inputPayload

  // Don't render the field if it didn't pass validation conditions
  // e.g. only display commercial categories if listing type is commercial
  if (!conditionsValid){
    return null
  }

  // @ts-expect-error TS2345
  const currentValue = getCurrentValue(inputComponent, value, defaultValue)

  // DynamicInput has no maxLength support, so cap the value before it reaches the form handler
  const onChange = (e?: ChangeEvent<HTMLInputElement>) => {
    if (!e) return

    if (maxLength && e.target.value.length > maxLength){
      e.target.value = e.target.value.slice(0, maxLength)
    }
    handlers.onChange(e)
  }

  return (
    // @ts-expect-error TS2322
    <Form.Field label={label || fieldKey} marginTop={marginTop}>
      <DynamicInput
        currentValue={currentValue}
        // @ts-expect-error TS2322
        inputComponent={inputComponent}
        // @ts-expect-error TS2322
        inputType={inputType}
        name="value"
        placeholder={defaultValue}
        // @ts-expect-error TS2322
        style={style}
        // @ts-expect-error TS2322
        valueType={valueType}
        values={values}
        {...handlers}
        onChange={onChange}
      />
      {maxLength && (
        <small>{`${String(currentValue || '').length}/${maxLength}`}</small>
      )}
    </Form.Field>
  )
}

export default PortalDataInput
